import Http from 'utils/Http';

const baseUrl = '/api/method';

const apiEndPoints = {
  getTournamentDetails: 'sfa_online.v1.profile.get_tournament_details',
  // getTournamentBasicInfo: '',
  // getTournamentContactDetails: '',
  // getTournamentPriceDetails: '',
  getTournamentSportList: '/sfa_online.v1.microsite.get_sports',
  getSportEventBasicInfo: '/sfa_online.v1.microsite.get_sport_details',
  getSportEventList: '/sfa_online.v1.microsite.get_sport_events',
  getSportEventListDirect: 'sfa_online.v1.microsite.get_sport_events',
  // getSportEventPriceDetails: '',
  // getDrawFormat: 'sfa_online.v1.digital_scoring.get_sport_event',
  getPointsMedals: 'sfa_online.v1.microsite.get_medal_points',
  getRankingTableList: 'sfa_online.v1.microsite.get_ranking_table',
  getWinnerTable: 'sfa_online.v1.microsite.get_winners',
  getParticipantList: 'sfa_online.v1.microsite.get_participants',
  getSportEvent: 'sfa_online.v1.digital_scoring.get_sport_event',
  getDrawDateList: 'sfa_online.v1.microsite.get_draw_dates',
  getSportList: `sfa_online.v1.digital_scoring.get_sports`,
  getGender: 'sfa_online.v1.digital_scoring.get_gender',
  getAgeGroup: 'sfa_online.v1.digital_scoring.get_age_group',
  getSportCategory: 'sfa_online.v1.digital_scoring.get_sport_category',
  getSubCategory: 'sfa_online.v1.digital_scoring.get_sub_category',
  getBuilderIoPage: 'sfa_online.v1.microsite.get_page',
  getShowReconciliationPage: 'sfa_online.v1.microsite.is_reconciliation_shown',
  getRulesAndPrice: 'sfa_online.v1.microsite.get_rules_and_price',
  getEventAttractions: 'sfa_online.v1.event_attractions.get_event_attractions',
  getSections: 'Gallery Section',
  getFolders: 'Gallery Folder',
  getMedia: 'Gallery Media Item',
};

export async function getTournamentDetails(params) {
  //   try {
  //     // const res = await fetch(baseUrl + apiEndPoints.getTournamentDetails).then((resp) =>
  //     //   resp.json()
  //     // );
  //     // return res.message.details;
  //     const res = {
  //       eventName: 'Khelo India Youth Games 2021-22, Haryana',
  //       city: 'Chandigarh',
  //       eventImage: '',
  //       banner: '',
  //       price: '350',
  //       remarks: 'This is one time tournament fees',
  //       startDate: '2022-02-04T00:00:00+05:30',
  //       endDate: '2022-02-15T00:00:00+05:30',
  //     };
  //     return res;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getTournamentDetails}?tournament_id=${params.tournament_id}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getTournamentBasicInfo(_params) {
  try {
    // const res = await fetch(
    //   baseUrl + apiEndPoints.getTournamentBasicInfo + `?tournament_id=${params.tournamentId}`
    // ).then((resp) => resp.json());
    // return res.message.details;
    return [
      {
        title: 'Basic Information',

        content: [
          {
            header: 'Description',

            value:
              'Khelo India Youth Games is a part of the revamped national programme for development of sports, Khelo India. After the resounding success of the Khelo India School Games in 2018, it is back in 2019 in a much bigger and better version as the Youth Games. For the first time students from colleges and universities are participating, and will have a total of 9000 participants. Now, these events will be held in Haryana.',
          },
          // {
          // header: 'Registration Dates',

          //   value: '20/07/2021 - 4/08/2021',
          // },
          {
            header: 'Tournament Venue',

            value: 'Khel Bhawan, Tau Devi Lal Sports Complex, Sector 3, Panchkula-134109',
          },
        ],
      },
    ];
    // eslint-disable-next-line no-unreachable
  } catch (error) {
    console.log(error);
  }
}

export async function getTournamentContactDetails(_params) {
  try {
    // const res = await fetch(
    //   baseUrl + apiEndPoints.getTournamentContactDetails + `?tournament_id=${params.tournamentId}`
    // ).then((resp) => resp.json());
    // return res.message.details;
    return [
      {
        title: 'Contact Information',

        content: [
          {
            header: 'Contact Person',

            value: 'Darlene Robertson',
          },
          {
            header: 'Contact Number',

            value: '(209) 555-0104',
          },
          {
            header: 'Address ',

            value: '2118 Thornridge Cir. Syracuse, Connecticut 35624',
          },
          {
            header: 'Email ID',

            value: 'georgia.young@example.com',
          },
        ],
      },
    ];
    // eslint-disable-next-line no-unreachable
  } catch (error) {
    console.log(error);
  }
}

export async function getTournamentPriceDetails(_params) {
  try {
    // const res = await fetch(
    //   baseUrl + apiEndPoints.getTournamentPriceDetails + `?tournament_id=${params.tournamentId}`
    // ).then((resp) => resp.json());
    // return res.message.details;
    return [
      {
        title: 'Prizes, Rules & Regulations Information',
        content: [
          {
            header: 'Rules and Regulations (General)',

            value:
              'Participate in the U/18 SFAPLAY.COM SUPER 30 Tennis Tournament 2021 CHALLENGE  - an international online chess tournament, open for ages 18 & below.',

            pdf_url: 'http://localhost:3000',
          },

          {
            header: 'Prize Information',

            value:
              'Participate in the U/18 SFAPLAY.COM SUPER 30 Tennis Tournament 2021 CHALLENGE  - an international online chess tournament, open for ages 18 & below.',

            pdf_url: 'http://localhost:3000',
          },
        ],
      },
    ];
    // eslint-disable-next-line no-unreachable
  } catch (error) {
    console.log(error);
  }
}

export async function getTournamentSportList(params) {
  try {
    const res = await fetch(
      baseUrl + apiEndPoints.getTournamentSportList + `?tournament=${params.tournamentId}`
    ).then((resp) => resp.json());
    const arr = res.message;
    const returnData = [];
    arr.map((item) => {
      returnData.push({
        img: item.image,
        title: item.sport,
        tags: [],
        status: null,
        button: null,
        detail_tags: [
          `${item.events} ${item.events === 1 ? 'Event' : 'Events'}`,
          item.city,
          `${item.start_date} - ${item.end_date}`,
        ],
      });
      return 0;
    });
    return returnData;
  } catch (error) {
    console.log(error);
  }
}

export async function getSportEventBasicInfo(params) {
  try {
    const res = await fetch(
      baseUrl +
        apiEndPoints.getSportEventBasicInfo +
        `?tournament=${params.tournament}&sport=${params.sport}`
    ).then((resp) => resp.json());
    const newArr = [];
    const [item] = res.message;
    // console.log('item', item);
    newArr.push({
      title: 'Basic Information',
      content: [
        {
          header: 'Sport Name',
          value: item.sport_name,
        },
        {
          header: 'Events Dates',
          value: {
            from: item.start_date,
            to: item.end_date,
          },
        },
        // {
        // header: 'Tournament Venue',
        //   value: {
        //     address: item.venue,
        //   },
        // },
      ],
    });
    return newArr;
  } catch (error) {
    console.log(error);
  }
}

export async function getSportEventList(params) {
  try {
    const res = await fetch(
      baseUrl +
        apiEndPoints.getSportEventList +
        `?tournament=${params.tournament}&sport=${params.sport}&age_group=${params.age_group}&gender=${params.gender}&date=${params.date}&fees_range=${params.fees_range}`
    ).then((resp) => resp.json());
    const newArr = [];
    res.message.forEach((item, index) => {
      // const [SportName, subCategory] = item.sport_event.split('-');
      newArr.push({
        sport_event: item.sport_event,
        type: item.type,
        sub_category: item.sub_category,
        id: index,
        // title: `${SportName}${subCategory ? '-' + subCategory : ''}`,
        title: `${item.sport}`,
        tags: [
          {
            text: item.gender,
            icon: item.gender,
            icon_color: 'fill-purple-550',
            color: 'text-purple-550',
            bg_color: 'bg-blue-150',
          },
          {
            text: item.age_group,
            icon: 'age_group',
            icon_color: 'text-gold-500',
            color: 'text-gold-500',
            bg_color: 'bg-gold-400',
          },
        ],
        price: `${item.currency === 'Rupees' ? '₹' : null} ${item.price}`,
        status: {
          text: item.status,
          color: 'text-gray-500',
          bg_color: 'bg-gray-300',
        },
        registration_open: item.registration_open,
        detail_tags: [`${item.start_date} - ${item.end_date}`],
      });
      // return 0;
    });
    return newArr;
  } catch (error) {
    console.log(error);
  }
}

export async function getSportEventPriceDetails(_params) {
  try {
    // const res = await fetch(
    //   baseUrl +
    //   apiEndPoints.getSportEventPriceDetails +
    //   `?tournament_id=${params.tournamentId}&sport_event_id=${params.sportEventId}`
    // ).then((resp) => resp.json());
    // return res.message.details;
    return [
      {
        title: 'Prizes, Rules & Regulations Information',

        content: [
          {
            header: 'Rules and Regulations (General)',

            value:
              'Participate in the U/18 SFAPLAY.COM SUPER 30 Tennis Tournament 2021 CHALLENGE  - an international online chess tournament, open for ages 18 & below.',

            pdf_url: 'http://localhost:3000',
          },

          {
            header: 'Prize Information',

            value:
              'Participate in the U/18 SFAPLAY.COM SUPER 30 Tennis Tournament 2021 CHALLENGE  - an international online chess tournament, open for ages 18 & below.',

            pdf_url: 'http://localhost:3000',
          },
        ],
      },
    ];
    // eslint-disable-next-line no-unreachable
  } catch (error) {
    console.log(error);
  }
}

export async function getDrawFormat(params) {
  // console.log('params', params);

  const fetchURL =
    baseUrl +
    apiEndPoints.getDrawFormat +
    `?tournament=${params.tournament}&sport=${params.sport}&gender=${params.gender}&age_group=${params.age_group}`;
  if (typeof params.sport_category !== 'object')
    fetchURL.concat(`&sport_category=${params.sport_category}`);
  if (typeof params.sub_category !== 'object')
    fetchURL.concat(`&sub_category=${params.sub_category}`);
  try {
    const res = await fetch(fetchURL).then((resp) => resp.json());
    return res.message[0];
  } catch (e) {
    console.log(e);
  }
}

export async function getSportEventListDirect(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getSportEventListDirect}?tournament=${params.tournament}&sport=${params.sport}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getPointsMedals(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getPointsMedals}?tournament=${params.tournament}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getRankingTableList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getRankingTableList}?tournament=${params.tournament}&preview=${params?.preview}&sport=${params?.sport}&event=${params?.event}&medal=${params?.medal}&round=${params?.round}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getWinnerTable(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getWinnerTable}?tournament=${params.tournament}&recent=${params?.recent}&sport=${params?.sport}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getParticipantList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getParticipantList}?tournament=${params.tournament}&date=${params.date}&sport=${params.sport}&round=${params.round}&gender=${params.gender}&age_group=${params.age_group}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getSportEvent(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getSportEvent}?tournament=${params.tournament}&sport=${params.sport}&gender=${params?.gender}&age_group=${params?.age_group}&sport_category=${params.sport_category}&sub_category=${params.sub_category}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getDrawDateList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getDrawDateList}?tournament=${params.tournament}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getSportList(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getSportList}?tournament=${params.tournament}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getGender(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getGender}?tournament=${params.tournament}&sport=${params.sport}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getAgeGroup(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getAgeGroup}?tournament=${params.tournament}&sport=${params.sport}&gender=${params.gender}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getSportCategory(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getSportCategory}?tournament=${params.tournament}&sport=${params.sport}&gender=${params.gender}&age_group=${params.age_group}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getSubCategory(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getSubCategory}?tournament=${params.tournament}&sport=${params.sport}&gender=${params.gender}&age_group=${params.age_group}&sport_category=${params.sport_category}`,
    });
    return res.message;
  } catch (error) {
    console.log(error);
  }
}

export async function getRules({ tournamentId, sport }) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getRulesAndPrice}?tournament=${tournamentId}&sport=${sport}`,
    });
    if (!res.message?.error) {
      return [
        {
          title: 'Prizes, Rules & Regulations Information',
          content: [
            {
              header: 'Rules and Regulations (General)',

              value: res?.message?.rules_and_regulations,

              pdf_url: res?.message?.rules_and_regulation_file,
            },

            {
              header: 'Prize Information',

              value: res?.message?.prize_information,

              pdf_url: res?.message?.prize_information_file,
            },
          ],
        },
      ];
    }
    return res;
  } catch (error) {
    console.log(error);
  }
}

export async function getBuilderIoPage(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getBuilderIoPage}?tournament=${params.tournament}&page_path=${params.page_path}`,
    });
    return res.message;
  } catch (error) {
    console.log({ error });
  }
}

export async function getShowReconciliation(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getShowReconciliationPage}?tournament=${params.tournament}`,
    });
    return res.message;
  } catch (error) {
    console.log({ error });
  }
}

export async function getEventAttractions(params) {
  try {
    const res = await Http.fetch({
      apiEndpoint: `${apiEndPoints.getEventAttractions}?tournament_id=${params.tournament_id}`,
    });
    return res.message;
  } catch (error) {
    console.log({ error });
  }
}

export async function getSectionList(params) {
  try {
    const res = await Http.fetchDB({
      apiEndpoint: `${apiEndPoints.getSections}?filters=[["tournament","=","${params.tournament_id}"]]&order_by=sequence_number`,
    });
    return res.data;
  } catch (error) {
    console.log({ error });
  }
}

export async function getSectionDetails(params) {
  try {
    const res = await Http.fetchDB({
      apiEndpoint: `${apiEndPoints.getSections}/${encodeURIComponent(params.section_name)}`,
    });
    return res.data;
  } catch (error) {
    console.log({ error });
  }
}

export async function getFolderList(params) {
  try {
    const res = await Http.fetchDB({
      apiEndpoint: `${apiEndPoints.getFolders}?filters=[["type","=","${encodeURIComponent(
        params.section_name
      )}"]]&order_by=sequence_number`,
    });
    return res.data;
  } catch (error) {
    console.log({ error });
  }
}

export async function getFolderDetails(params) {
  try {
    const res = await Http.fetchDB({
      apiEndpoint: `${apiEndPoints.getFolders}/${encodeURIComponent(params.folder_name)}`,
    });
    return res.data;
  } catch (error) {
    console.log({ error });
  }
}

export async function getMediaList(params) {
  try {
    const res = await Http.fetchDB({
      apiEndpoint: `${apiEndPoints.getMedia}?filters=[["folder","=","${encodeURIComponent(
        params.folder_name
      )}"],["hide","=",0]]&order_by=sequence_number`,
    });
    return res.data;
  } catch (error) {
    console.log({ error });
  }
}

export async function getMediaDetails(params) {
  try {
    const res = await Http.fetchDB({
      apiEndpoint: `${apiEndPoints.getMedia}/${encodeURIComponent(params.media_item)}`,
    });
    return res.data;
  } catch (error) {
    console.log({ error });
  }
}
